var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3625 3.82227H5.50772C4.48646 3.82227 3.65088 4.65784 3.65088 5.67911V20.5338C3.65088 21.5551 4.48646 22.3907 5.50772 22.3907H20.3625C21.3837 22.3907 22.2193 21.5551 22.2193 20.5338V5.67911C22.2193 4.65784 21.3837 3.82227 20.3625 3.82227ZM9.22141 19.6054H6.43614V11.2496H9.22141V19.6054ZM7.82877 9.67132C6.90035 9.67132 6.15762 8.92858 6.15762 8.00016C6.15762 7.07174 6.90035 6.329 7.82877 6.329C8.75719 6.329 9.49993 7.07174 9.49993 8.00016C9.49993 8.92858 8.75719 9.67132 7.82877 9.67132ZM19.434 19.6054H16.6488V14.6848C16.6488 13.9421 15.9989 13.2922 15.2561 13.2922C14.5134 13.2922 13.8635 13.9421 13.8635 14.6848V19.6054H11.0782V11.2496H13.8635V12.3637C14.3277 11.621 15.349 11.064 16.1846 11.064C17.9486 11.064 19.434 12.5494 19.434 14.3134V19.6054Z",
    fill: "#6B767F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.2b80c5fce730a6c2c08129d9d884693e.svg";
export { ForwardRef as ReactComponent };